import React, { useEffect, useState } from "react";
import axiosInstance from "../../interceptor/axiosInstance";
import { useNavigate } from "react-router-dom";
import "../Dashboard/Dashboard.css";

const ManageAgents = () => {
  const navigate = useNavigate();
  const [agentList, setAgentList] = useState([]);
  const [maxAgents, setMaxAgents] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAgents = async () => {
      try {
        const response = await axiosInstance.get(`/agent/list`);
        setAgentList(response.data);
      } catch (err) {
        setError("Error fetching agent data.");
      } finally {
        setLoading(false);
      }
    };

    const getAccess = async () => {
      try {
        const response = await axiosInstance.get(`/org/check-access`);
        const maxAgentSetting = response.data.find(
          (setting) => setting.setting_key === "max_agents"
        );
        if (maxAgentSetting) {
          setMaxAgents(parseInt(maxAgentSetting.setting_value, 10));
        }
      } catch (err) {
        console.error("Error fetching access settings", err);
      }
    };

    fetchAgents();
    getAccess();
  }, []);

  if (loading) {
    return (
      <div className="dash-spinner">
        <div className="spinner-ring"></div>
      </div>
    );
  }

  if (error) {
    return <div className="agents-page"><p style={{ color: '#bb0403' }}>{error}</p></div>;
  }

  const isAddDisabled = maxAgents !== null && agentList.length >= maxAgents;

  return (
    <div className="agents-page">
      <div className="agents-inner">

        {/* Info Banner */}
        <div className="agents-info-banner">
          Add agents to allow them to connect with customers via live chat.
        </div>

        {/* Header */}
        <div className="agents-header">
          <h1 className="agents-title">Manage Agents</h1>
          <div style={{ display: 'flex', alignItems: 'center', gap: '14px', flexWrap: 'wrap' }}>
            {isAddDisabled && (
              <span className="limit-warning">
                Agent limit reached ({maxAgents}). Contact support for more.
              </span>
            )}
            {maxAgents !== null && (
              <span style={{ fontSize: '14px', color: '#475569', fontWeight: 500 }}>
                {agentList.length} / {maxAgents} agents
              </span>
            )}
            <button
              className="btn-add-agent"
              onClick={() => navigate("/add-agent")}
              disabled={isAddDisabled}
            >
              + Add Agent
            </button>
          </div>
        </div>

        {/* Table */}
        <div className="agents-table-wrap">
          <table className="agents-table">
            <thead>
              <tr>
                <th>Agent Code</th>
                <th>Agent Name</th>
                <th>Email</th>
                <th>Current Status</th>
                <th>Status</th>
                <th>Created At</th>
              </tr>
            </thead>
            <tbody>
              {agentList && agentList.length > 0 ? (
                agentList.map((agent) => (
                  <tr key={agent.agent_id}>
                    <td style={{ fontWeight: 600, fontFamily: 'monospace', fontSize: '13px', color: '#475569' }}>
                      {agent.agentCode}
                    </td>
                    <td style={{ fontWeight: 500 }}>{agent.agentName}</td>
                    <td style={{ color: '#475569' }}>{agent.agentEmail}</td>
                    <td>{agent.agentCurrentStatus}</td>
                    <td>
                      <span className={`agent-status-badge ${agent.agentStatus ? 'active' : 'inactive'}`}>
                        {agent.agentStatus ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                    <td style={{ color: '#475569', fontSize: '13px' }}>
                      {new Date(agent.agentCreatedAt).toLocaleString()}
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="no-agents-row">
                  <td colSpan="6">
                    <div style={{ fontSize: '20px', marginBottom: '10px', color: '#cbd5e1' }}>—</div>
                    No agents yet. Click <strong>+ Add Agent</strong> to get started.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
};

export default ManageAgents;
